import type { FC } from 'react'

import { EditSolidIcon } from '@dhl-ui/icons'
import { useNativeBridge } from '@dhl/native-bridge'
import { usePutProfilePicture } from '@dhl/receiver-profile-api'

import { Badge, IconButton } from '@dhl-ui/components'
import { useApp } from '~/context/index.js'
import { ProfileAvatar } from './ProfileAvatar.js'

export const EditableProfileAvatar: FC = () => {
  const { isAvatarEditSupported, onReceiveAvatar, requestChangeAvatar } = useNativeBridge()
  const { mutate: mutateProfilePicture } = usePutProfilePicture()
  const { refetchAvatar } = useApp()

  onReceiveAvatar((payload) => {
    mutateProfilePicture(
      {
        data: new Blob([Uint8Array.from(atob(payload.data), (c) => c.charCodeAt(0))]),
      },
      {
        onSuccess: () => {
          refetchAvatar()
        },
      }
    )
  })

  const avatar = <ProfileAvatar size="xl" />

  if (!isAvatarEditSupported()) {
    return avatar
  }

  return (
    <Badge
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      badgeContent={
        <IconButton
          aria-label="edit avatar"
          color="primary"
          size="small"
          variant="contained"
          onClick={requestChangeAvatar}
        >
          <EditSolidIcon />
        </IconButton>
      }
      overlap="circular"
      variant="standard"
    >
      {avatar}
    </Badge>
  )
}
